import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { InvoiceService } from '@fitness-force/api';
import { AppErrors } from '@fitness-force/errors';
// import { FactoryHttpLoader } from '@fitness-force/shared';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PopoverModule } from 'primeng/popover';
import { ToastMessageService } from '@fitness-force/api';
import { voidInvoiceRequest } from '@fitness-force/models';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [    CommonModule,
    DividerModule,
    TimelineModule,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    PdfViewerModule,
    PopoverModule,
    TranslateModule],
})
export class InvoiceDetailsComponent implements OnInit {
  @Input('showInvoice') showInvoicePopup: boolean = false;
  @Input('clientId') clientId: number = 0;
  @Input('tenantId') tenantId: number = 0;
  @Input('invoiceId') invoiceId: number = 0;
  @Input('number_prefix') number_prefix: string = "";

  @Output('closeInvoice') closeInvoice: EventEmitter<boolean> = new EventEmitter();

  pdfSrc = new BehaviorSubject<string>('');
  showVoidInvoiceModal: boolean = false;
  voidInvoiceForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private invoiceService: InvoiceService,
    private translate: TranslateService,
    private toastMessageService: ToastMessageService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.GetInvoicePdf();
  }

  ngAfterViewInit() {
    this.voidInvoiceForm = this.fb.group({
      void_reason: [''],
    });
  }



  GetInvoicePdf() {
    this.invoiceService.getInvoicePDF(this.clientId, this.invoiceId)
      .subscribe({
        next: (data: any) => {
          this.pdfSrc.next(data);
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  printInvoice() {
    window.open(this.pdfSrc.value, '_blank');
  }

  downloadInvoice() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', this.pdfSrc.value);
    link.setAttribute('download', `invoice.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  SendInvoicePDF(channel: string) {
    let channels: any[] = [];
    channels.push(channel);
    this.invoiceService.SendInvoicePDF(this.clientId, this.invoiceId, channels)
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('TRANSACTION.MSG.INVOICE_MAIL_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
        },
        error: (error: AppErrors) => {
          if (error.originalError.status == 200) {
            this.toastMessageService.showSuccess(error.originalError.error.text);
          }
          else {
            this.ShowToastErrors(error);
          }
        },
      });
  }

  deleteInvoice(form: UntypedFormGroup) {
    let voidRequest: voidInvoiceRequest = {} as voidInvoiceRequest;
    voidRequest.void_reason = form.value.void_reason;
    this.invoiceService.voidInvoice(
      this.tenantId,
      this.clientId,
      this.invoiceId,
      voidRequest
    )
      .subscribe({
        next: (data: any) => {
          this.translate
            .get('TRANSACTION.MSG.INVOICE_VOID_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.showVoidInvoiceModal = false;
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
        },
      });
  }

  closeInvoicePopup() {
    this.showInvoicePopup = false;
    this.closeInvoice.emit(false);
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(error.originalError.error.errorMessage);
    }
  }
}